export const APP_NAME = 'GoldMine Vision';
export const APP_TAGLINE = 'See the Signal.';
export const APP_DOMAIN = 'goldminevision.com';

export const API_BRIDGE_EXTENSION_ID =
  import.meta.env.VITE_API_BRIDGE_EXTENSION_ID || 'bkloapinbgeodaadceokcfbdhephmhni';

export const API_BRIDGE_DOWNLOAD_URL =
  import.meta.env.VITE_API_BRIDGE_DOWNLOAD_URL ||
  `${import.meta.env.BASE_URL}downloads/gmv-bridge-extension.zip`;
